import styled from '@emotion/styled';

export const Submit = styled.div`
  margin-top: 24px;
`;
